import { useState } from 'react'
import { svgs } from '../../assets/svgs'
import { useGlobalState } from '../../hooks/useGlobalState'
import { ACTIONS } from '../../state'
import { extractAddons, formatNumber, getUniqueById } from '../../utils/funcs'

export const Summary = () => {
   const { currStageIdx, price, discount, eventDate, promoCode, dispatch, calculateTotal, cart } = useGlobalState()
   const [isActive, setIsActive] = useState(false)

   const date = new Date(eventDate)
   const options = { year: 'numeric', month: 'long' }
   const formattedDate = date.toLocaleDateString('en-US', options)

   const handelDiscount = (e) => {
      e.preventDefault()
      if (!promoCode) return
      setIsActive(true)
      setTimeout(() => {
         setIsActive(false)
      }, 1000)
      dispatch({ type: ACTIONS.SET, entity: 'calculateTotal', payload: !calculateTotal })
   }

   return (
      <div className={`summary stage-${currStageIdx}`}>
         <header>
            <div className='circle upleft'></div>
            <div className='circle upright'></div>
            <div className='circle middleleft'></div>
            <div className='circle middleright'></div>
            <div className='recs'>
               <div />
               <div />
               <div />
               <div />
               <div />
            </div>
            <h6>{formattedDate}</h6>
            {svgs.eventLogo2}
         </header>
         <main>
            <h5>Order Summary</h5>
            {/* {discount > 0 && <h6>Early Bird Discount</h6>} */}
            <span></span>
            <section className='table-header'>
               <div>
                  <h6>Qty</h6><h6>Pass Type</h6><h6>Price</h6>
               </div>
            </section>
            <section className='table-body'>
               {
                  getUniqueById(extractAddons(cart)).map((item, idx) =>
                     <div key={idx}>
                        <div>
                           <h6>{item.amountOfTickets / (item.ticket.increment_by || 1)}</h6><h6>{item.ticket.name}</h6><h6>${item.amountOfTickets * item.ticket.cost / (item.ticket.increment_by || 1)}</h6>
                        </div>
                     </div>
                  )
               }
               {price.discount > 0 && <h4><span>1</span> <span>Promo Discount</span> <span>-${formatNumber(price.discount)}</span></h4>}
            </section>
            <section className='promo-code'>
               <form onSubmit={handelDiscount}>
                  <input onChange={(e) => dispatch({ type: ACTIONS.SET, entity: 'promoCode', payload: e.target.value })} placeholder='Promo Code' type="text" value={promoCode} />
                  <button className={isActive ? 'active' : ''}>Apply</button>
               </form>
               {promoCode && <h3>{price.discount > 0 ? '*Applied Successfully' : '*Promo Code Invalid'}</h3>}
            </section>
         </main>
         <footer>
            <div className='circle bottomleft'></div>
            <div className='circle bottomright'></div>
            <section className='fees'>
               <h6>Fees</h6><h6>${formatNumber(price.fees)}</h6>
            </section>
            <span></span>
            <section className='total'>
               <h6>Total<small>including Fees</small></h6><h6>${formatNumber(price.total)}</h6>
            </section>
         </footer>
      </div>
   )
}
